import getFeeByDay from "../getFeeByDay";
import priceToMonedaElegida from "../priceToMonedaElegida";

const getPriceFromMonths = (
    date,
    arrayMonths,
    moneda_precio_base,
    arrayFees,
    fee_cliente_siempre,
    fee_propietario_siempre
) => {
    let response = {};

    arrayMonths.some((month) => {
        if (date.getMonth() === month.mes) {
            let ambos_fee = {
                fee_cliente: Number(
                    (
                        month.precio / (1 - fee_cliente_siempre / 100) -
                        month.precio
                    ).toFixed(2)
                ),
            };

            if (arrayFees.length > 0) {
                ambos_fee = getFeeByDay(
                    date,
                    arrayFees,
                    fee_cliente_siempre,
                    fee_propietario_siempre,
                    month.precio
                );
            }

            return (response = {
                hasProperty: true,
                total: month.precio,
                fee_cliente: ambos_fee.fee_cliente,
                tiene_fee_por_fecha: ambos_fee.tiene_fee_por_fecha,
            });
        } else {
            response = { hasProperty: false };
        }
    });

    return response;
};

export default getPriceFromMonths;
